/**
 * pdp-nav.js
 *
 * Two responsibilities — loaded globally on every page via theme.liquid:
 *
 * 1. LISTING PAGE: When __pdpNavConfig.isListing is true, save the current
 *    full URL (including query params/filters) to sessionStorage so a
 *    subsequent PDP back link can restore it.
 *
 * 2. PDP PAGE: If a .pdp-back link exists, compare the saved listing path
 *    against the link's default href. If they match, upgrade the href to
 *    the full saved URL so the user returns to exactly where they left off
 *    (e.g. /pages/tournaments?state=CA, /collections/shop?search=cue).
 *
 * Cross-section contamination is prevented by the path-match check — a
 * tournament listing URL won't override a product PDP's back link.
 */
(function () {
    var STORAGE_KEY = 'plp_last_listing';
    var cfg = window.__pdpNavConfig;

    var normalizePath = function (path) {
        return path.replace(/\/+$/, '');
    };

    var getPathname = function (href) {
        return normalizePath(new URL(href, window.location.origin).pathname);
    };

    var inferListingPathFromLocation = function () {
        var currentPath = normalizePath(window.location.pathname || '');
        var parts = currentPath.split('/').filter(Boolean);
        if (parts.length !== 2) return '';

        var root = parts[0];
        if (root !== 'pages' && root !== 'collections') return '';

        return '/' + parts.join('/');
    };

    // ── 1. LISTING PAGE: save current URL ─────────────────────────────────────
    var listingPathToSave = '';
    if (cfg && cfg.isListing && cfg.defaultPath) {
        listingPathToSave = normalizePath(cfg.defaultPath);
    } else {
        listingPathToSave = inferListingPathFromLocation();
    }

    if (listingPathToSave) {
        var persistListingUrl = function () {
            try {
                sessionStorage.setItem(
                    STORAGE_KEY,
                    JSON.stringify({ url: window.location.href, path: listingPathToSave })
                );
            } catch (e) {
                // sessionStorage blocked (private mode, storage full, etc.) — silent fail
            }
        };

        // Initial save on page load.
        persistListingUrl();

        // Keep saved URL in sync when filters update URL via History API.
        var originalPushState = history.pushState;
        history.pushState = function () {
            var result = originalPushState.apply(history, arguments);
            persistListingUrl();
            return result;
        };

        var originalReplaceState = history.replaceState;
        history.replaceState = function () {
            var result = originalReplaceState.apply(history, arguments);
            persistListingUrl();
            return result;
        };

        window.addEventListener('popstate', persistListingUrl);

        // Save again right before navigation when the user opens a PDP from this PLP.
        document.addEventListener('click', function (event) {
            var anchor = event.target && event.target.closest ? event.target.closest('a[href]') : null;
            if (!anchor) return;
            try {
                var targetPath = getPathname(anchor.href);
                var matchesPdp = targetPath.indexOf(listingPathToSave + '/') === 0;
                if (matchesPdp) persistListingUrl();
            } catch (e) {
                // ignore invalid href
            }
        }, true);
    }

    // ── 2. PDP PAGE: restore back link if path matches ─────────────────────────
    var backLink = document.querySelector('.pdp-back');
    if (!backLink) return;

    try {
        var defaultPath = getPathname(backLink.href);
        var stored = sessionStorage.getItem(STORAGE_KEY);

        if (stored) {
            var data = JSON.parse(stored);
            if (data && data.url && data.path && normalizePath(data.path) === defaultPath) {
                backLink.href = data.url;
                return;
            }
        }

        var referrer = document.referrer;
        if (referrer) {
            var referrerUrl = new URL(referrer, window.location.origin);
            if (referrerUrl.origin === window.location.origin && getPathname(referrerUrl.href) === defaultPath) {
                backLink.href = referrerUrl.href;
            }
        }
    } catch (e) {
        // URL parsing or JSON parse error — leave default href untouched
    }
})();
